import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CreateEngineer from "./engineer/CreateEngineer";
import EditEngineer from "./engineer/EditEngineer";

/**
 * Drawer lateral para criar ou editar engenheiros
 * Similar ao ProjectDrawer
 */
export default function EngineerDrawer({ open, onClose, mode = "create", engineerId, onEngineerCreated }) {
  const [currentMode, setCurrentMode] = useState(mode);

  // Atualizar mode quando props mudarem
  useEffect(() => {
    setCurrentMode(mode);
  }, [mode]);

  const handleClose = () => {
    onClose();
  };

  const title = currentMode === "create" ? "Novo Engenheiro" : "Editar Engenheiro";

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2,
      }}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: "600px", md: "800px" },
          maxWidth: "90vw",
        },
      }}
    >
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
            {currentMode === "create" && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                Preencha os dados para cadastrar um novo engenheiro
              </Typography>
            )}
          </Box>
          <IconButton onClick={handleClose} edge="end" sx={{ ml: 2 }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider />

        {/* Content */}
        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          {currentMode === "create" ? (
            <CreateEngineer onEngineerCreated={(engineerId) => {
              onEngineerCreated?.(engineerId);
              // Não fecha imediatamente - CreateEngineer controla o timing
            }} />
          ) : (
            <EditEngineer
              initialEngineerId={engineerId}
              onSuccess={handleClose}
            />
          )}
        </Box>
      </Box>
    </Drawer>
  );
}
